import ListingVM from './listing-vm';
export default {
  init: function(){
    console.log('Initializing Kadenze.AdminInstitutionListing');
    var institutions_data = JSON.parse($('#institutions_json').val());
    ko.applyBindingsWithValidation(new ListingVM(institutions_data), document.getElementById('admin_institution_listing'));
  }
};

